import React from 'react';
import { Box, Typography } from '@mui/material';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import BedtimeOutlinedIcon from '@mui/icons-material/BedtimeOutlined';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const DEFAULT_GROUPS = {
  morning: {
    label: 'Morning',
    hint: 'Until 12 PM',
    icon: WbSunnyRoundedIcon,
    color: colors.app.timeline.morning,
  },
  afternoon: {
    label: 'Afternoon',
    hint: '12 - 5 PM',
    icon: SpaOutlinedIcon,
    color: colors.app.timeline.afternoon,
  },
  evening: {
    label: 'Evening',
    hint: 'After 5 PM',
    icon: BedtimeOutlinedIcon,
    color: colors.app.timeline.evening,
  },
};

/**
 * TimeGroupHeader - Header for time period groups (Morning, Afternoon, Evening)
 */
const TimeGroupHeader = ({
  label,
  period,
  entryCount = 0,
  icon: IconOverride = null,
  iconColor,
}) => {
  const groupConfig = DEFAULT_GROUPS[period] || DEFAULT_GROUPS.morning;
  const IconComponent = IconOverride || groupConfig.icon;
  const labelText = label || groupConfig.label;
  const tone = iconColor || groupConfig.color || colors.semantic.ink;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        width: '100%',
        py: 0.1,
        minWidth: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.9, minWidth: 0 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(tone, 0.12),
            color: tone,
            flexShrink: 0,
          }}
        >
          <IconComponent sx={{ fontSize: 14 }} />
        </Box>

        <Typography
          sx={{
            fontSize: { xs: '1rem', md: '1.08rem' },
            fontWeight: 800,
            lineHeight: 1.2,
            letterSpacing: 0,
            color: colors.semantic.ink,
            whiteSpace: 'nowrap',
          }}
        >
          {labelText}
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize: { xs: '0.78rem', md: '0.82rem' },
          fontWeight: 700,
          lineHeight: 1.2,
          color: colors.semantic.ink2,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {`${entryCount} ${entryCount === 1 ? 'entry' : 'entries'}`}
      </Typography>
    </Box>
  );
};

export default TimeGroupHeader;
